import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const DollarIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height='15'
            viewBox='0 0 10 15'
            width='10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='m.574 8.575 1.309-.085c.068 1.717 1.105 2.72 2.55 2.94V7.624l-.901-.187C1.968 7.146.88 6.246.88 4.58c0-1.82 1.343-3.026 3.553-3.094V.006h.952v1.53c2.159.256 3.417 1.633 3.434 3.792l-1.309.068C7.459 3.9 6.677 2.948 5.385 2.693V6.45l.731.136c1.938.374 2.924 1.19 2.924 2.907 0 1.887-1.53 3.009-3.655 3.094v1.547h-.952V12.57C2.172 12.349.574 10.938.574 8.575Zm5.066-.731-.255-.051v3.689c1.36-.085 2.261-.782 2.261-1.887 0-.986-.629-1.48-2.006-1.751Zm-3.383-3.35c0 1.072.731 1.48 1.955 1.718l.221.05V2.609c-1.411.05-2.176.714-2.176 1.887Z'
                fill={color} />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default DollarIcon;
